import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { PARTNER_BRAND, PARTNER_BRAND_HOVER } from '../partnerDashboardTheme';
import { PortalPageHeader } from '../../layout/PortalPageHeader';
import { useEventsScope } from '../../../contexts/EventsScopeContext';
import PartnerEventsListSection from './PartnerEventsListSection';

const PartnerEvents = () => {
  const navigate = useNavigate();
  const { routes } = useEventsScope();

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <PortalPageHeader title="Events" />
      <Box
        sx={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'flex-end',
          alignItems: 'center',
          mb: 2.5,
        }}
      >
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(routes.new)}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            borderRadius: '20px',
            px: 2.5,
            py: 1,
            bgcolor: PARTNER_BRAND,
            boxShadow: 'none',
            '&:hover': {
              bgcolor: PARTNER_BRAND_HOVER,
              boxShadow: 'none',
            },
            width: { xs: '100%', sm: 'auto' },
          }}
        >
          Add New Event
        </Button>
      </Box>

      <PartnerEventsListSection />
    </Box>
  );
};

export default PartnerEvents;
